<template>
  <nav class="r6-navigation" :aria-label="$t('cyberboardR6.title')">
    <router-link
      v-for="item in items"
      :key="item.path"
      :to="{
        path: item.path,
        query: {
          light:
            lightPosition === null
              ? $route.query.light
              : String(lightPosition + 1),
        },
      }"
      exact
      class="item"
    >
      <i class="iconfont iconarrow-right" />
      <span class="navigation-label px">{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CyberboardR6Navigation",
  props: {
    lightPosition: {
      type: Number,
      default: null,
    },
    deviceInfo: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState("loader", {
      bridge: "bridge",
    }),
    currentDeviceInfo() {
      return (
        this.deviceInfo ||
        (this.bridge?.isConnected && this.bridge.cdc
          ? this.bridge.deviceInfo
          : null)
      );
    },
    items() {
      const items = [
        {
          path: this.$paths.indexR6,
          label: this.$t("cyberboardR6.overview"),
        },
        {
          path: this.$paths.lightR6,
          label: this.$t("selectVersion.led"),
        },
        {
          path: this.$paths.inSwitchLEDR6,
          label: this.$t("keyboard.inSwitchLED"),
        },
        {
          path: this.$paths.keyboardR6,
          label: this.$t("index.keyboardTitle"),
        },
      ];
      if (this.currentDeviceInfo?.audioSupported) {
        items.push({
          path: this.$paths.deviceConfig,
          label: this.$t("deviceConfig.title"),
        });
      }
      if (this.currentDeviceInfo?.firmwareSupported) {
        items.push({
          path: this.$paths.r6Firmware,
          label: this.$t("cyberboardR6.firmwareUpdate"),
        });
      }
      return items.filter((item) => this.$route.path !== item.path);
    },
  },
};
</script>

<style lang="scss" scoped>
.r6-navigation {
  position: fixed;
  right: 20px;
  bottom: 200px;
  z-index: 4;
  font-size: 18px;

  .item {
    display: flex;
    align-items: center;
    width: 210px;
    color: #ffffff;
    text-decoration: none;
    cursor: pointer;

    + .item {
      margin-top: 14px;
    }

    &:hover {
      color: $primary-color;
    }
  }

  i {
    display: block;
    width: 48px;
    height: 48px;
    margin-right: 14px;
    padding-left: 4px;
    border-radius: 9px;
    background: $primary-color;
    color: #ffffff;
    font-size: 20px;
    line-height: 48px;
    text-align: center;
  }
}

.r6-navigation .navigation-label.px {
  font-size: max(10px, 0.18rem);
}

@media (max-width: 720px) {
  .r6-navigation {
    right: 8px;
    bottom: 84px;
    font-size: 13px;

    .item {
      width: 150px;
    }

    .navigation-label.px {
      font-size: max(10px, 0.13rem);
    }

    i {
      width: 36px;
      height: 36px;
      margin-right: 8px;
      font-size: 16px;
      line-height: 36px;
    }
  }
}
</style>
